(() => {
  const reducedMotion = () => window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const movement = () => reducedMotion() ? 'auto' : 'smooth';
  const readJSON = (root, selector) => {
    try {
      return JSON.parse(root.querySelector(selector)?.textContent || '{}');
    } catch {
      return {};
    }
  };

  const initializeOffer = root => {
    const find = prefix => root.querySelector(`[id^="${prefix}-"]`);
    const overlay = find('CamilleOfferOverlay');
    const panel = find('CamilleOfferPanel');
    const checkingCard = find('CamilleCheckingCard');
    const closeButton = find('CamilleCloseOffer');
    const addButton = find('CamilleAddToCart');
    const mediaTrack = find('CamilleMediaTrack');
    const video = find('CamilleVideo');
    const playButton = find('CamillePlayVideo');
    const labels = readJSON(root, '[data-al-funnel-labels]');
    const images = readJSON(root, '[data-al-funnel-images]');
    if (!overlay || !panel || !closeButton || !addButton) return;
    let returnFocus;
    let priorOverflow;
    let finish = '';
    let size = '';
    let toastTimeout;
    const showToast = text => {
      const toast = find('CamilleToast');
      if (!toast) return;
      toast.textContent = text;
      toast.classList.add('show');
      clearTimeout(toastTimeout);
      toastTimeout = setTimeout(() => toast.classList.remove('show'), 4500);
    };
    const close = () => {
      overlay.classList.remove('open', 'checking');
      overlay.setAttribute('aria-hidden', 'true');
      panel.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = priorOverflow;
      returnFocus?.focus();
    };
    const open = button => {
      returnFocus = button;
      priorOverflow = document.body.style.overflow;
      checkingCard.hidden = true;
      overlay.classList.remove('checking');
      overlay.classList.add('open');
      overlay.setAttribute('aria-hidden', 'false');
      panel.setAttribute('aria-hidden', 'false');
      panel.scrollTop = 0;
      document.body.style.overflow = 'hidden';
      closeButton.focus();
    };
    root.querySelectorAll('.camille-check-price-trigger').forEach(button => {
      button.addEventListener('click', () => open(button));
    });
    closeButton.addEventListener('click', close);
    overlay.addEventListener('click', event => {
      if (event.target === overlay) close();
    });
    overlay.addEventListener('keydown', event => {
      if (event.key === 'Escape') {
        event.preventDefault();
        close();
      }
      if (event.key !== 'Tab') return;
      const focusable = [...panel.querySelectorAll('a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), summary, [tabindex="0"]')].filter(node => node.getClientRects().length);
      const first = focusable[0];
      const last = focusable[focusable.length - 1];
      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last?.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first?.focus();
      }
    });
    root.querySelectorAll('[data-camille-finish]').forEach(button => {
      button.addEventListener('click', () => {
        finish = button.dataset.camilleFinish;
        root.querySelectorAll('[data-camille-finish]').forEach(option => {
          const selected = option === button;
          option.classList.toggle('selected', selected);
          option.setAttribute('aria-pressed', String(selected));
        });
        find('CamilleSelectedFinish').textContent = finish;
        find('CamillePreviewFinish').textContent = finish;
        const metal = finish === '18K Gold' ? 'gold' : 'silver';
        const preview = find('CamilleOfferImage');
        preview.src = images[metal];
        preview.alt = labels[`${metal}_image_alt`];
        find('CamilleFinishMaterial').textContent = labels[`${metal}_material`];
      });
    });
    root.querySelectorAll('[data-camille-size]').forEach(button => {
      button.addEventListener('click', () => {
        size = button.dataset.camilleSize;
        root.querySelectorAll('[data-camille-size]').forEach(option => {
          const selected = option === button;
          option.classList.toggle('selected', selected);
          option.setAttribute('aria-pressed', String(selected));
        });
        find('CamilleSelectedSize').textContent = size;
      });
    });
    addButton.addEventListener('click', () => {
      showToast(labels.offer_unavailable);
      window.location.assign(root.dataset.productUrl);
    });
    const moveMedia = direction => {
      mediaTrack?.scrollBy({left: mediaTrack.clientWidth * direction, behavior: movement()});
    };
    find('CamilleMediaPrev')?.addEventListener('click', () => moveMedia(-1));
    find('CamilleMediaNext')?.addEventListener('click', () => moveMedia(1));
    mediaTrack?.addEventListener('scroll', () => {
      const index = Math.round(mediaTrack.scrollLeft / Math.max(1, mediaTrack.clientWidth));
      root.querySelectorAll('.camille-dot').forEach((dot, dotIndex) => dot.classList.toggle('on', dotIndex === index));
    }, {passive: true});
    const playVideo = () => {
      if (!video || !playButton) return;
      video.play().then(() => playButton.classList.remove('show')).catch(() => playButton.classList.add('show'));
    };
    playButton?.addEventListener('click', playVideo);
    playVideo();
  };

  const initializeWizard = root => {
    const showStep = (number, shouldScroll = true) => {
      const steps = [...root.querySelectorAll('.cf-step')];
      if (!steps.some(step => Number(step.dataset.step) === number)) return;
      steps.forEach(step => {
        const active = Number(step.dataset.step) === number;
        step.hidden = !active;
        step.classList.toggle('is-active', active);
      });
      const progress = root.querySelector('.cf-progress-fill');
      if (progress) progress.style.width = `${number / steps.length * 100}%`;
      if (!shouldScroll) return;
      root.scrollIntoView({behavior: movement(), block: 'start'});
      const heading = root.querySelector('.cf-step.is-active h1, .cf-step.is-active h2');
      if (heading) {
        heading.tabIndex = -1;
        heading.focus({preventScroll: true});
      }
    };
    root.querySelectorAll('[data-finish]').forEach(button => {
      button.addEventListener('click', () => {
        root.querySelectorAll('[data-finish]').forEach(option => option.setAttribute('aria-pressed', String(option === button)));
        showStep(2);
      });
    });
    root.querySelectorAll('[data-next], [data-back]').forEach(button => {
      button.addEventListener('click', () => showStep(Number(button.dataset.next || button.dataset.back)));
    });
    showStep(1, false);
  };

  const initialize = scope => {
    scope.querySelectorAll('[data-al-funnel]').forEach(root => {
      if (root.dataset.alInitialized === 'true') return;
      root.dataset.alInitialized = 'true';
      if (root.dataset.alFunnel === 'offer') initializeOffer(root);
      if (root.dataset.alFunnel === 'wizard') initializeWizard(root);
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initialize(document));
  else initialize(document);
  document.addEventListener('shopify:section:load', event => initialize(event.target));
})();
